export default "__VITE_ASSET__Ct1UF527__"